class MessageParser {
	
	constructor(actionProvider) {
    	this.actionProvider = actionProvider;
  	}

  	async parse(message) {
    	const lowercase = message.toLowerCase();

    	if (lowercase.includes("hello")) {
      		this.actionProvider.greet();
    	}

    	else {
			this.actionProvider.clientMessage(message);
		}

  	}
}

export default MessageParser;